module.exports = __webpack_public_path__ + "static/media/manage-employees.0180751d.svg";